import { cilNoteAdd } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { Icon } from "cx/widgets";
import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { API_URL, TUS_URL } from "src/setup/helper/apiUrl";
import Swal from "sweetalert2";
import { Upload } from "tus-js-client";

const ReactDropzone = ({
  programFiles,
  setProgramFiles,
  submitButtonDisable,
  setFieldValue,
  labelText,
  formikFilesName,
  isFieldValue,
  activityGuid,
  tusFiles,
}) => {
  const removeFile = (file) => () => {
    const newFiles = [...programFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setProgramFiles(newFiles);
  };


  useEffect(() => {
    if (programFiles.length > 1) {
      const names = programFiles.map((e) => e.name);
      const uniqueNames = new Set(names);
      if (names.length !== uniqueNames.size) {
        const newFiles = [...programFiles];
        newFiles.pop(); // Son eklenen dosyayı çıkarır
        setProgramFiles(newFiles);
        Swal.fire({
          icon: "error",
          title: "Hata Oluştu!",
          text: "Aynı dosyayı tekrar yükleyemezsiniz.",
          confirmButtonText: "Tamam",
        });
      }
    }
  }, [programFiles]);
  

  console.log("programFilesprogramFiles",programFiles)

  const [activeUpload, setActiveUpload] = useState(null);

  const [isLoading, setIsLoading] = useState(0);

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const upload = new Upload(file, {
          endpoint: `${TUS_URL}/files`,
          retryDelays: [0, 1000, 3000, 30000],
          chunkSize: 1024 * 1024 * 4, //4mb
          metadata: {
            filename: file.name,
            filetype: file.type,
          },
          onError: function (error) {
            console.log("Failed because: " + error);
          },
          onProgress: function (bytesUploaded, bytesTotal) {
            setHasSwalStarted(true);
            setTimeout(() => {
              const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(
                2
              );
              console.log(bytesUploaded, bytesTotal, percentage + "%");
              setIsLoading(parseFloat(percentage));
            }, [3000]);
          },
          onSuccess: function () {
            const parts = upload.url.split("/files/");
            if (parts.length > 1) {
              tusFiles({ fileName: file.name, tusFileName: parts[1] });
            }

            setIsLoading(0);
            setHasSwalStarted(false);
          },
        });

        setActiveUpload(upload);

        // Check for previous uploads to continue
        upload.findPreviousUploads().then((previousUploads) => {
          if (previousUploads.length) {
            upload.resumeFromPreviousUpload(previousUploads[0]);
          }
          // Start the upload
          upload.start();
        });
      });

      setProgramFiles([...programFiles, ...acceptedFiles]);
    },
    [programFiles]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop,
  });
  const files = programFiles?.map((file) => (
    <li key={file.path} className="mb-1">
      <button
        type="button"
        disabled={submitButtonDisable}
        className="btn btn-warning text-white me-2"
        onClick={removeFile(file)}
      >
        <i className="bi bi-trash"></i>
      </button>
      {file.path} {/* - {file.size} bytes{" "} */}
    </li>
  ));

  const [hasSwalStarted, setHasSwalStarted] = useState(false);

  /*  useEffect(() => {
    if (isLoading === 100) {
      Swal.update({
        title: "Dosya Yüklendi",
        text: "Upload complete!",
      });
      setHasSwalStarted(false); // Reset for next file upload
    } else if (isLoading !== 0) {
      if (!hasSwalStarted) {
        Swal.fire({
          title: "Dosya Yükleniyor...",
          text: `${isLoading}%`,
        });
        setHasSwalStarted(true);
      } else {
        Swal.update({
          text: `${isLoading}%`,
        });
      }
    }
  }, [isLoading, hasSwalStarted]); */

  const handleCancelUpload = () => {
    if (activeUpload) {
      activeUpload.abort();
      setActiveUpload(null); // Reset the active upload
    }
  };

  return (
    <div>
      <div className="row d-flex mb-2 mt-1 ">
        <div className="col-12 col-xs-12 col-md-5 ps-5 d-flex col-sm-12   align-items-center">
          {labelText}
        </div>
        {hasSwalStarted && activeUpload && (
          <div
            className=" position-absolute top-0 start-0 h-100 w-100 d-flex justify-content-center align-items-center swal2-backdrop-hide"
            style={{ zIndex: 30 }}
          >
            <div
              className=" border border-2 border-secondary bg-secondary bg-opacity-75 rounded-3  d-flex flex-column justify-content-center align-items-center"
              style={{ width: "400px", height: "240px" }}
            >
              <div> Dosya Yükleniyor... </div>
              <div> {isLoading}% </div>
              {activeUpload && (
                <button
                  className=" mt-4 btn btn-danger"
                  onClick={handleCancelUpload}
                >
                  Cancel Upload
                </button>
              )}
            </div>
          </div>
        )}
        <div className=" col-12  col-sm-12 col-md-7 px-5 ">
          <div className="border-Custom border p-2 w-auto ">
            {isFieldValue && (
              <UploadFilestoFormik
                formikFilesName={formikFilesName}
                programfiles={programFiles}
                setFieldValue={setFieldValue}
              />
            )}

            <div {...getRootProps({ className: "dropzone " })}>
              <div className="" style={dropzoneStyle}>
                <input
                  {...getInputProps()}
                  disabled={submitButtonDisable}
                  name="file"
                />
                <button
                  type="button"
                  disabled={submitButtonDisable}
                  className="btn btn-secondary d-flex justify-content-center text-white align-items-center px-2 pe-3 "
                  onClick={open}
                >
                  {" "}
                  Dosya seçiniz veya sürükleyiniz
                </button>

                <p></p>

                <aside>
                  <h4>Files</h4>
                  <ul style={{ listStyle: "none" }}>{files}</ul>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row d-flex mb-2 mt-1 " style={{placeContent:"end"}}>
        <div style={{ width: "55%" }}>
          <span className="text-danger" style={{fontSize:"14px"}}>
            Lütfen dosya yüklerken, dosya isimlerinin aynı olmamasına ve bütün
            dosyalarınızın tek bir rar veya zip dosyası olarak yüklenmesine
            dikkat ediniz.
          </span>
        </div>
      </div>
    </div>
  );
};

/* const buttonStyle = {
  backgroundColor: "#fafafa",
  border: "1px dashed #B88846",
  color: "#B88846",
}; */
const dropzoneStyle = {
  minHeight: 150,
};
const UploadFilestoFormik = ({
  programfiles,
  setFieldValue,
  formikFilesName,
}) => {
  useEffect(() => {
    console.log(formikFilesName, programfiles);
    setFieldValue(formikFilesName, programfiles);
  }, [programfiles]);

  return <div></div>;
};
export default ReactDropzone;
